<template>
	<div v-parallax-fit="parallax" class="circle">
		<img src="/themes/rise-theme/dist/images/estate/character-view/holly/31_FannyMae.png" alt="">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 23500,
						end: 24300,
						fromStyle: { transform: 'scale(0)' },
           				toStyle: { transform: 'scale(1)' },
						easing: 'linear'
					},
					{
						start: 24300,
						end: 25100,
						fromStyle: { transform: 'translateY(0%) scale(1)' },
           				toStyle: { transform: 'translateY(350%) scale(1)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.circle {
		position: fixed;
		top: calc(50% - 230px);
		right: calc(50% - 650px);
		max-width: 400px;
		transition: all 0.1s linear;
		z-index: 2;
	}

	@media screen and (max-width: 1600px) {
        .circle {
        	top: calc(50% - 175px);
        	right: calc(50% - 500px);
            max-width: 300px;
        }
    }

    @media screen and (max-width: 1024px) {
        .circle {
        	top: calc(50% - 175px);
        	right: calc(50% - 350px);
        	max-width: 250px;
        }
    }

    @media screen and (max-width: 650px) {
    	.circle {
    		top: calc(50% - 100px);
    		right: calc(50% - 180px);
    		max-width: 150px;
        }
    }
</style>
